import React, { useState } from 'react'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface SelectComponentProps {
  selectedDate: Date | null;
  handleDateChange: (date: string) => void;
}

const DateSelectionComponent: React.FC<SelectComponentProps> = ({selectedDate, handleDateChange}) => {
  const [showDatePicker, setShowDatePicker] = useState(false);

  const convertDateToCustomFormatDob = (date: Date) => {
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Local month
    const dd = String(date.getDate() + 1).padStart(2, '0'); // Local date
    const yyyy = date.getFullYear(); // Local year
    return `${yyyy}-${mm}-${dd}`;
  };

  const dateChanged = (date: Date | null) => {
    if (date) {
      handleDateChange(convertDateToCustomFormatDob(date));
      setShowDatePicker(false);
    }
  };

  const formatDisplayDate = (date: Date | null) => {
    if (!date) return '';
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };

  return (
    <div className="relative">
      {showDatePicker ? (
        <DatePicker
          id="datepicker"
          selected={selectedDate}
          onChange={dateChanged}
          onClickOutside={() => setShowDatePicker(false)}
          open={true}
          className="p-1 border border-black bg-primary dark:bg-secondary text-sm rounded-md text-white focus:outline-none focus:border-blue-500"
        />
      ) : (
        <button
          onClick={() => setShowDatePicker(true)}
          className="p-1 px-2 border border-black bg-primary dark:bg-secondary text-sm rounded-md text-white focus:outline-none focus:border-blue-500 min-w-[90px]"
        >
          {formatDisplayDate(selectedDate)}
        </button>
      )}
    </div>
  );
}

export default DateSelectionComponent
